module.exports = __webpack_public_path__ + "punch-white.svg?c64f6a2c698b542d6a7097b4cfcba36a";